<div class="performance-questionnaire" *ngIf="visibility">
  <h3 class="header title">
    {{ 'module.energyMap.detailPV.performanceBenchMarkingTitleText' | translate }}
  </h3>
  <div class="body">
    <div class="input-group">
      <label class="survey">{{ 'module.energyMap.detailPV.performanceQuestion1Text' | translate }}</label>
      <label class="label">{{ 'module.energyMap.detailPV.performanceQuestion1UnitText' | translate }}</label>
      <app-input-group class="app-input-group" [value]="alignment" (valueChange)="onAligmentChange($event)" [type]="'number'" [unit]="'Grad'"></app-input-group>
    </div>

    <div class="input-group">
      <label class="survey">{{ 'module.energyMap.detailPV.performanceQuestion2Text' | translate }}</label>
      <app-input-group
        class="app-input-group"
        [value]="tiltAngle"
        (valueChange)="onTiltAngleChange($event)"
        [type]="'number'"
        [unit]="'Grad'"
      ></app-input-group>
    </div>
  </div>
  <div class="footer">
    <button class="btn btn-primary -border-inverted btn-previous" (click)="previous()">Abbrechen</button>
    <button class="btn btn-primary -border-inverted btn-next" (click)="next()">Weiter</button>
  </div>
</div>
